import React from "react";

export const Marker = ({ children }: any) => {
  return (
    <b style={{ background: "linear-gradient(transparent 70%, #c1e0ff 70%)" }}>
      {children}
    </b>
  );
};

export default Marker;
